import styled, { css } from 'styled-components'
import { rgba } from 'polished'

type WrapperProps = {
  cellRelative?: boolean
  isRowClickable?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  margin-top: 24px;
  flex: 1;
  overflow-y: auto;
  z-index: 1;
  box-shadow: 0px 0px 8px ${rgba(45, 47, 52, 0.16)};

  .MuiPaper-root {
    width: 100%;

    * {
      font-family: Poppins !important;
    }
  }

  .MuiTableHead-root,
  .MuiTableCell-head {
    max-height: 500px;
    background-color: ${({ theme }) => theme.ds.colors.primary50} !important;
    border-bottom: none !important;
    z-index: 1;
  }

  .MuiTableCell-head,
  .MuiButton-label {
    font-weight: 600;
    color: ${({ theme }) => theme.ds.colors.primary700};
  }

  tr {
    background-color: ${({ theme }) => theme.ds.colors.white};
    &:nth-child(even) {
      background-color: ${({ theme }) => theme.ds.colors.neutral50} !important;
    }

    ${(props) =>
      !!props.isRowClickable &&
      css`
        &:hover:not(.MuiTableRow-footer) {
          background-color: ${({ theme }) =>
            theme.ds.colors.neutral100} !important;
        }
      `}

    td {
      border-color: ${({ theme }) => theme.ds.colors.neutral100} !important;
    }
  }

  ${(props) =>
    props.cellRelative &&
    css`
      .MuiTableCell-body {
        position: relative;
      }
    `}

  ${(props) =>
    !!props.isRowClickable &&
    css`
      .MuiTableBody-root {
        .MuiTableRow-root {
          cursor: pointer;
        }
      }
    `}
`

export const LoadingMore = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;

  img {
    height: 40px;
  }
`
